import type {DSConfig} from '../dsConfig'
import responsiveConfig from './responsiveConfig'

const config = {
    ...responsiveConfig,
    modulesList: [
        ...responsiveConfig.modulesList,
        'themeCssVariablesPublicAPI',
        'mobileAlgoPublicApi',
        'contextsPublicAPI',
        'bindingsPublicAPI',
        'runtimeBindingsPublicAPI'
    ],
    extensionsList: [
        ...responsiveConfig.extensionsList,
        'layoutSettings',
        'mobileAlgo',
        'contexts',
        'bindings',
        'runtimeBindings'
    ],
    experimentalConfigOptions: {
        ...responsiveConfig.experimentalConfigOptions,
        dm_enforceStrictValidationEverywhere: {
            configOptions: {
                enforceStrictValidationEverywhere: true
            }
        },
        dm_enforceNoWhitelistDalStrictSchemaValidation: {
            configOptions: {
                enforceNoWhitelistDalStrictSchemaValidation: true
            }
        }
    }
}
export default config satisfies DSConfig
